import {CarouselProvider, Slide, Slider} from "pure-react-carousel";
import 'pure-react-carousel/dist/react-carousel.es.css'
import QuizSlider from "./QuizSlider";
import {useRef, useState} from "react";

function QuizPanel({open, show, questions, setPanel, quiz}) {
    const control = useRef()
    const [nextTimer, setNextTimer] = useState(null)

    const handle = {
        next: () => setNextTimer(setTimeout(() => control.current.querySelector(".next").click(), 3000))
    }

    return (
        <div className={`quiz-panel ${open ? "open" : ""}`}>
            <div className={`quiz-panel-content ${show ? "show" : ""}`}>
                {
                    questions ?
                        <CarouselProvider naturalSlideWidth={4} naturalSlideHeight={3} totalSlides={questions.length} dragEnabled={false} touchEnabled={false}>
                            <Slider>
                                {questions.map(q => <Slide index={q.id} key={q.id}>{quiz(q, handle.next)}</Slide>)}
                            </Slider>
                            <QuizSlider setPanel={setPanel} control={control} timer={nextTimer} />
                        </CarouselProvider>
                        : quiz(setPanel)
                }
            </div>
        </div>
    )
}

export default QuizPanel